import { Tags } from "@/enum/tags";
import { apiSlice } from "../http";

/**
 * Interface para uma mudança de campo dentro de um evento
 */
export interface AuditFieldChange {
  field: string;
  from?: any;
  to?: any;
}

export interface AuditLogEvent {
  id: number;
  entity_type: string;
  entity_id: string;
  event_type: string;
  event_payload: {
    // Formato antigo (para compatibilidade)
    domain?: string;
    field?: string;
    from?: string;
    to?: string;
    reason?: string;
    action?: string;
    target?: Record<string, any>;
    metadata?: Record<string, any>;
    // Novo formato com payload rico
    changes?: AuditFieldChange[];
    message?: string;
  };
  action: string;
  email: string;
  ip?: string;
  url?: string;
  method?: string;
  information?: string;
  entity_name?: string;
  status?: string;
  created_at: string;
}

export interface AuditLogResponse {
  entity_type: string;
  entity_id: string;
  total: number;
  events: AuditLogEvent[];
}

export interface GetAuditLogParams {
  entity_type: string;
  entity_id: string;
  event_type?: string;
  actor_email?: string;
  date_from?: string;
  date_to?: string;
}

export const auditLogApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEntityAuditHistory: builder.query<AuditLogResponse, GetAuditLogParams>({
      query: ({ entity_type, entity_id, event_type, actor_email, date_from, date_to }) => {
        const params = new URLSearchParams();

        if (event_type) params.append('event_type', event_type);
        if (actor_email) params.append('actor_email', actor_email);
        if (date_from) params.append('date_from', date_from);
        if (date_to) params.append('date_to', date_to);

        const queryString = params.toString();
        const url = `/audit-log/entity/${entity_type}/${entity_id}${queryString ? `?${queryString}` : ''}`;

        return {
          url,
          method: "GET",
        };
      },
      providesTags: [Tags.EMAIL_REPORT, Tags.GROUP_AUDIT],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetEntityAuditHistoryQuery,
  useLazyGetEntityAuditHistoryQuery,
} = auditLogApi;
